import React from 'react';
import {Text} from 'react-native';
import PropTypes from 'prop-types';
import styles from '../../../style/adminTools';
import {splitAtMatch} from '../tenantPage/settingsSearch';

const HighlightedLabel = ({text, query, style, testID}) => {
  const parts = splitAtMatch(text, query);
  if (!parts) {
    return (
      <Text style={style} testID={testID}>
        {text}
      </Text>
    );
  }
  return (
    <Text style={style} testID={testID}>
      {parts.before}
      <Text
        style={styles.settingLabelMatch}
        testID={testID ? `${testID}-mark` : undefined}
      >
        {parts.match}
      </Text>
      {parts.after}
    </Text>
  );
};

HighlightedLabel.propTypes = {
  text: PropTypes.string.isRequired,
  query: PropTypes.string,
  style: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
  testID: PropTypes.string
};

export default HighlightedLabel;
